import { Status as RocketchatAPIResponseStatus } from "@daangn/idl/rocketchat/api/api";
import { z } from "zod";

export const RocketchatErrorSchema = z.object({
  id: z.string(),
  name: z.string(),
  status: z.nativeEnum(RocketchatAPIResponseStatus),
  status_message: z.string(),
});

export type RocketchatError = z.infer<typeof RocketchatErrorSchema>;

export const isRocketchatError = (
  error: unknown,
): error is z.infer<typeof RocketchatErrorSchema> => {
  return RocketchatErrorSchema.safeParse(error).success;
};

export const MAX_MESSAGE_LENGTH = 1000;
export const errorMessageMap = {
  [RocketchatAPIResponseStatus.BLOCKED_USER]: "Unable to message this user",
  [RocketchatAPIResponseStatus.BLOCKED_BY_ME]:
    "You can't message this user, please unblock them first.",
  [RocketchatAPIResponseStatus.TOO_LONG_CONTENT]:
    "Message is too long. Shorten your message to 1000 characters or less.",
  [RocketchatAPIResponseStatus.BLOCKED_STATUS_USER]:
    "Unable to message blocked user.",
};
